import React, { useEffect, useState } from 'react';
import { importFontAwesomeV4, importMomentTimezone, importStripeJS } from 'Helpers/External';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';

export const withPaymentPageDependencies = Wrapped => props => {
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState();
  useEffect(() => {
    Promise.all([importStripeJS(), importFontAwesomeV4()])
      .then(() => setLoaded(true))
      .catch(setErr);
    // Don't await this, but we'll need moment-timezone eventually
    importMomentTimezone().catch(setErr);
  }, []);

  return (
    <FullScreenDataContainer
      loading={!loaded}
      loadingError={err}
      component={Wrapped}
      componentProps={props}
    />
  );
};
